
import moment from "moment"
export default {
  SET_STATISTICS (state, statistics) {
    state.statisticsList = statistics
  },
  SET_DIMENSION (state, dimension) {
    state.dimension = dimension
  },
  SET_SECONDARY_DIMENSION (state, dimension) {
    state.secondaryDimension = dimension
  },
  SET_RANGE (state, range) {
    state.range = range
  },
  SET_IS_LOADING (state, isLoading) {
    state.isLoading = isLoading
  },
  SET_IS_LOADING_DASHBOARD (state, isLoading) {
    state.dashboard.isLoading = isLoading
  },
  SET_STATISTICS_DASHBOARD (state, statistics) {
    state.dashboard.statistics = statistics
  },
  SET_IS_LOADING_MONTH_COMPARISON (state, isLoading) {
    state.monthComparison.isLoading = isLoading
  },
  SET_STATISTICS_MONTH_COMPARISON (state, statistics) {

    const currentMonth = moment(state.monthComparison.range.end).format("M")
    const previousMonth = moment(state.monthComparison.range.start).format("M")

    state.monthComparison.currentMonth.data = statistics.filter(x => moment(x.date).format("M") === currentMonth)
    state.monthComparison.previousMonth.data = statistics.filter(x => moment(x.date).format("M") === previousMonth)
  },
}

